export default __webpack_public_path__ + "static/media/178.9acb05bb.png";